<template>
	<div id="Main">
		<setpbox :type="type"></setpbox>
		<div v-if="type==2">
			<div class="imgbox">
				<div class="title">
					<p class="p1">请上传托管卡照片</p>
					<p class="p2">下方可预览各版本托管卡样本</p>
				</div>
				<van-row type="flex" justify="space-between" class="samplebox">
					<van-col class="sample" @click="sampleshow(0)">
						<van-icon class="icon" :name="require('../../assets/images/service/sample.png')" />样本一</van-col>
					<van-col class="sample" @click="sampleshow(1)">
						<van-icon class="icon" :name="require('../../assets/images/service/sample.png')" />样本二</van-col>
					<van-col class="sample" @click="sampleshow(2)">
						<van-icon class="icon" :name="require('../../assets/images/service/sample.png')" />样本三</van-col>
				</van-row>
				<div class="uploadbox uploadbox70">
					<van-uploader class="Positive" preview-size="100%" v-model="Escrow " :max-count="1">
						<van-image width="100%" fit="contain" :src="require('../../assets/images/service/Escrow.png')" />
					</van-uploader>
				</div>
				<van-button round type="info" class="submit" @click="submit(2)">下一步</van-button>
			</div>
			<van-overlay class="popup" :show="show">
				<div class="centen">
					<van-image width="100%" fit="contain" :src="sample[sampleindex]" />
					<p>样本</p>
					<van-icon class="icon" name="close" @click="show = false" />
				</div>
			</van-overlay>
		</div>
		<div v-if="type==3" class="type3">
			<div class="imgbox">
				<van-image class="img" width="100%" fit="contain" :src="require('../../assets/images/service/face.png')" />
				<van-button round type="info" class="submit" @click="submit(3)">开始人脸识别</van-button>
			</div>
		</div>
		<div v-if="type==4">
			<div class="imgbox">
				<div class="title">
					<p class="p1">我的信息</p>
					<p class="p2">请检查上传信息是否正确</p>
				</div>
				<div class="inputbox">
					<span class="label">
						<van-icon class="icon" :name="require('../../assets/images/service/phone.png')" />手机号：</span>
					<span class="input">{{phone}}</span>
				</div>
				<div class="inputbox">
					<span class="label">
						<van-icon class="icon" :name="require('../../assets/images/service/account.png')" />账户号：</span>
					<span class="input">{{user}}<span class="tisp">(股权账户号/股东编号)</span></span>
				</div>
				<div class="inputbox bor0">
					<span class="label">
						<van-icon class="icon" :name="require('../../assets/images/service/Escrowicon.png')" />托管卡：</span>
				</div>
				<van-image class="img" width="70%" fit="contain" :src="escrowCardshow" />
				<div class="inputbox bor0">
					<span class="label">
						<van-icon class="icon" :name="require('../../assets/images/service/faceid.png')" />身份证：</span>
				</div>
				<van-image class="img" width="100%" fit="contain" :src="idCardPositive" />
				<van-image class="img" width="100%" fit="contain" :src="idCardReverse" />
				<van-button round type="info" class="submit" @click="submit(4)" v-if="!over">申请</van-button>
			</div>
		</div>
	</div>
</template>
<script>
	import setpbox from '../../components/setboxhu';
	import axiosPost from '../../libs/moudle/index.js';


	export default {
		components: {
			setpbox
		},
		data() {
			return {
				//imgurl: 'https://new.cdtg.com.cn:8082/',
				imgUrl: 'https://m.cdtg.com.cn:8082/',
				type: 2,
				/* 步骤数 */
				phone: '',
				/* 手机号 */
				user: '',
				/* 股东账号 */
				Positive: [],
				/* 正面图片 */
				verso: [],
				/* 国徽图片 */
				Escrow: [],
				/* 托管卡图片 */
				show: false,
				/* 样本展示 */
				idCardPositive: '',
				/* 正面地址 */
				idCardReverse: '',
				/*国徽地址 */
				escrowCard: '',
				escrowCardshow: '',
				/*, 托管卡地址 */
				url: '',
				/* 人脸地址所有数据 */
				token: '',
				/* 人脸token */
				timedata: '',
				/* 人脸验证开始时间 */
				faceKerneJson: '',
				/*,人脸josn */
				idCard: '', //身份证
				realName: '', //姓名
				over: false,
				/* 表示最终审核提交 */
				sampleindex: 0,
				sample: [
					require('../../assets/images/service/sample1.jpg'),
					require('../../assets/images/service/sample2.jpg'),
					require('../../assets/images/service/sample3.jpg'),
				],
				openId: '',
				loadingfaceurl: false //人脸识别地址是否获取中
			}
		},
		watch: {
			Escrow(val) { /* 托管卡 */
				if (val.length != 0) {
					this.compressFile(val[0].file);
				} else {
					this.escrowCard = ''
				}
			}
		},
		methods: {
			compressFile(file) { //文件压缩
				window.console.log('starfile', file);
				let t = this;
				var fileObj = file;
				var reader = new FileReader()
				reader.readAsDataURL(fileObj) //转base64
				reader.onload = function(e) {
					var image = new Image() //新建一个img标签（还没嵌入DOM节点)
					image.src = e.target.result
					image.onload = function() {
						var canvas = document.createElement('canvas'), // 新建canvas
							context = canvas.getContext('2d'),
							imageWidth = image.width / 2, //压缩后图片的大小
							imageHeight = image.height / 2,
							data = ''
						canvas.width = imageWidth
						canvas.height = imageHeight
						context.drawImage(image, 0, 0, imageWidth, imageHeight)
						data = canvas.toDataURL('image/jpeg') // 输出压缩后的base64
						var arr = data.split(','),
							mime = arr[0].match(/:(.*?);/)[1], // 转成blob
							bstr = atob(arr[1]),
							n = bstr.length,
							u8arr = new Uint8Array(n);
						while (n--) {
							u8arr[n] = bstr.charCodeAt(n);
						}
						let files = new window.File([new Blob([u8arr], {
							type: mime
						})], fileObj.name, {
							type: fileObj.type
						}) // 转成file					
						//callback(files) // 回调
						window.console.log('files-----', files);
						let formData = new FormData();
						formData.append('myFiles', file)
						let tpsat = t.$toast.loading({
							message: '上传中...',
							forbidClick: true,
							duration: 0
						});
						axiosPost.upload(formData).then((res) => {
							tpsat.clear()
							if (res.data.code == 200) {
								t.$toast({
									duration: 4000,
									message: '上传成功！'
								});
								t.escrowCard = res.data.data.savePath
							} else {
								t.$toast({
									duration: 4000,
									message: '上传失败请重新上传！'
								});
								t.Escrow = []
							}
						})
					}
				}

			},
			sampleshow(index) {
				this.sampleindex = index
				this.show = true;
			},
			submit(type) {
				if (this.loadingfaceurl == true) {
					this.$toast({
						duration: 4000,
						message: '请稍后，正在获取身份证地址！'
					});
					return false
				}
				if (type == 2) { /* 托管卡身份证提交 */
					if (this.escrowCard.length == 0) {
						this.$toast({
							duration: 4000,
							message: '请上传托管卡！'
						});
						return false;
					}
					let par = { /* 资料 */
						phone: this.phone,
						/* 手机号 */
						shareholderCode: this.user,
						/* 股东账号 */
						escrowCard: this.escrowCard,
						/* 托管卡 */
						openId: this.openId,
						/* 微信openId */
					}
					this.type = 3;
					this.ajax(par)
				} else if (type == 3) {
					window.location.href = this.url.Url /* 跳转第三方链接 */
				} else {

					axiosPost.checkRealNameAuthApply({ //是否已经申请
						shareholderCode: axiosPost.user(this.user),
					}).then((res) => {
						window.console.log(res)
						if (res.data.code == 200) {
							if (res.data.data == true) {
								let cardtime = '';
								if (JSON.parse(JSON.parse(this.faceKerneJson).DetectInfo).Text.OcrValidDate.indexOf('长期') > -1) {
									cardtime = '2099-12-31'
								} else {
									// cardtime=JSON.parse(JSON.parse(this.faceKerneJson).DetectInfo).Text.OcrValidDate.match(/(?<=-)(\d|\.)+/)[0].replace(/\./g,'-')
									cardtime = JSON.parse(JSON.parse(this.faceKerneJson).DetectInfo).Text.OcrValidDate.split('-')[1].replace(
										/\./g, '-')
								}
								let par = { /* 资料 */
									shareholderCode: this.user,
									/* 股东账号 */
									faceKerneTime: this.timedata,
									/* 人脸时间 */
									validityTime: cardtime,
									/* 证件有效期 */
									faceKerneCode: 0,
									/* 人脸code */
									faceKerneJson: this.faceKerneJson,
									/* 人脸josn */
									idCard: this.idCard,
									realName: this.realName,
									openId: this.openId
								}
								this.ajaxend(par) //最后一步调用不同方法
							} else {
								this.$toast({
									duration: 4000,
									message: res.data.msg
								});
								return false;
							}
						} else {
							this.$toast({
								duration: 4000,
								message: res.data.msg
							});
						}
					}).catch((res) => {
						window.console.log(res)
					})

				}
			},
			Journal() { /* 用户日志 */
				axiosPost.Journal({
					type: '实名认证',
					title: JSON.parse(JSON.parse(this.faceKerneJson).DetectInfo).Text.Name + '提交了实名认证申请',
					details: JSON.parse(JSON.parse(this.faceKerneJson).DetectInfo).Text.Name + '提交了实名认证申请',
					userId: this.user,
					userName: JSON.parse(JSON.parse(this.faceKerneJson).DetectInfo).Text.Name,
					logDate: this.timedata,
					/* 时间 */
				}).then((res) => {
					window.console.log(res)
				}).catch((res) => {
					window.console.log(res)
				})
			},
			ajaxend(par) { /* 提交实名数据数据 */
				axiosPost.updRealNameAuth(par).then((res) => {
					window.console.log(res)
					if (res.data.code == 200) {
						window.console.log(res)
						if (this.type == 3) { /* 如果是转到人脸识别就获取人脸地址 */
							this.geturl();
						}
						if (this.type == 4) { /* 实名认证成功 */
							this.$toast({
								duration: 4000,
								message: '提交成功！'
							});
							this.Journal();
							this.over = true
							this.$router.push({
								path: '/msghtml',
								query: {
									text: '实名认证申请成功！'
								}
							})
						}
						window.console.log(res)
					} else {
						this.$toast({
							duration: 4000,
							message: res.data.msg
						});
					}
				}).catch((res) => {
					window.console.log(res)
				})
			},
			ajax(par) { /* 提交实名数据数据 */
				axiosPost.ShareholderReal(par).then((res) => {
					window.console.log(res)
					if (res.data.code == 200) {
						window.console.log(res)
						if (this.type == 3) { /* 如果是转到人脸识别就获取人脸地址 */
							this.geturl();
						}
						if (this.type == 4) { /* 实名认证成功 */
							this.$toast({
								duration: 4000,
								message: '提交成功！'
							});
							this.Journal();
							this.over = true
							this.$router.push({
								path: '/msghtml',
								query: {
									text: '实名认证申请成功！'
								}
							})
						}
						window.console.log(res)
					} else {
						this.$toast({
							duration: 4000,
							message: res.data.msg
						});
					}
				}).catch((res) => {
					window.console.log(res)
				})
			},
			geturl() { /* 获取人脸地址 */
				let t = this;
				t.loadingfaceurl = true;
				axiosPost.AuthResult({
					redirectUrl: '/attestationidentity?openId=' + this.openId + '&time=' + this.time(),
					openId: this.openId
				}).then((res) => {
					window.console.log(res)
					if (res.data.code == 200) {
						this.url = JSON.parse(res.data.data)
						window.console.log("地址:"+this.url)
						t.loadingfaceurl = false;
					} else {
						this.$toast({
							duration: 4000,
							message: res.data.msg
						});

					}
				}).catch((res) => {
					window.console.log(res)
				})
			},
			time() { /* 验证时间开始计算 */
				let nowData = new Date()
				let month = nowData.getMonth() + 1;
				let strDate = nowData.getDate();
				if (month >= 1 && month <= 9) {
					month = "0" + month;
				}
				if (strDate >= 0 && strDate <= 9) {
					strDate = "0" + strDate;
				}
				let hour = nowData.getHours(); //得到小时
				let minu = nowData.getMinutes(); //得到分钟
				let sec = nowData.getSeconds(); //得到秒
				let time = nowData.getFullYear() + '-' + month + '-' + strDate + ' ' + hour + ':' + minu + ':' + sec
				return time;
			},
			judge(tpsat, token) { /* 根据token获取人脸结果 */
				axiosPost.getjudge({
					bizToken: token
				}).then((res) => {
					tpsat.clear()
					if (res.data.code == 200) {
						this.faceKerneJson = res.data.data
						if (JSON.parse(JSON.parse(this.faceKerneJson).DetectInfo).Text.ErrCode == 0) { /* 成功 */
							this.getdata();
							this.idCardPositive = 'data:image/png;base64,' + JSON.parse(JSON.parse(this.faceKerneJson).DetectInfo).IdCardData
								.OcrBack
							this.idCardReverse = 'data:image/png;base64,' + JSON.parse(JSON.parse(this.faceKerneJson).DetectInfo).IdCardData
								.OcrFront
							this.idCard = JSON.parse(JSON.parse(this.faceKerneJson).DetectInfo).Text.IdCard
							this.realName = JSON.parse(JSON.parse(this.faceKerneJson).DetectInfo).Text.Name
							this.$toast({
								duration: 4000,
								message: '人脸验证成功'
							});
							this.type = 4;
						} else { /* 失败 */
							this.$toast({
								duration: 4000,
								message: '人脸验证失败！请重新验证'
							});
						}
					} else {
						this.$toast({
							duration: 4000,
							message: res.data.msg
						});
					}
				}).catch((res) => {
					tpsat.clear()
					window.console.log(res)
				})
			},
			getdata() { /* 获取实名信息回显 */
				axiosPost.getRealNameApplyByOpenId({
					openId: this.openId
				}).then((res) => {
					if (res.data.code == 200) {

						this.escrowCard = res.data.data.escrowCard;
						if (res.data.data.escrowCard) {
							this.escrowCardshow = this.imgUrl + res.data.data.escrowCard
						}

						this.phone = res.data.data.phone
						this.user = res.data.data.shareholderCode ? res.data.data.shareholderCode : this.user;
					} else {
						this.$toast({
							duration: 4000,
							message: res.data.msg
						});
					}
				}).catch((res) => {
					window.console.log(res)
				})
			},
			gettoken() { /* 获取token */
				let tpsat = this.$toast.loading({
					message: '处理中',
					forbidClick: true,
					duration: 0
				});
				axiosPost.getBizTokenByOpenId({
					openId: this.openId
				}).then((res) => {
					if (res.data.code == 200) {
						this.judge(tpsat, res.data.data);
					} else {
						tpsat.clear()
						this.$toast({
							duration: 4000,
							message: '获取结果失败，请重新认证！'
						});
					}
				}).catch((res) => {
					tpsat.clear()
					window.console.log(res)
				})
			}
		},
		mounted() {
			this.openId = this.$route.query.openId
			if (this.$route.query.time) { /* 有tocken第三方人脸后返回(第三方回来是没有phone的) */
				this.timedata = this.$route.query.time
				this.gettoken();
				this.type = 3;
			} else {
				this.user = this.$route.query.user
				this.phone = this.$route.query.phone
			}
		}
	}
</script>

<style lang="scss" scoped>
	#Main {
		padding: 1.3rem;
		text-align: left;

		.type3 {
			.img {
				margin: 4rem 0;
			}

			.step {
				margin: 1rem 0;

				.box {
					font-size: 1.3rem;
					text-align: center;

					.icon {
						font-size: 1.9rem;
						margin-bottom: 0.2rem;
					}
				}
			}
		}

		.popup {
			display: flex;
			justify-content: center;
			align-items: center;

			.centen {
				width: 80%;
				text-align: center;
				color: #fff;
				font-size: 1.6rem;

				.icon {
					font-size: 3rem;
					color: rgba(255, 255, 255, .7);
				}

				p {
					padding: 1rem 0;
				}
			}
		}

		.samplebox {
			font-size: 1.8rem;
			color: #0078ff;
			margin-bottom: 3rem;
			margin-top: -0.5rem;

			.sample {
				.icon {
					vertical-align: middle;
					margin-right: 0.5rem;
					font-size: 2rem;
				}
			}
		}

		.submit {
			width: 100%;
			background-color: #fa6b6b;
			border: 0;
			margin-bottom: 2rem;
		}

		.uploadbox70 {
			width: 80%;
			margin: 0 auto;
		}

		.uploadbox {
			.Positive {
				width: 100%;
				font-size: 0;
				margin-bottom: 2rem;
			}

			.verso {
				width: 100%;
				font-size: 0;
				margin-bottom: 3rem;
			}
		}

		.imgbox {
			margin-top: 2rem;

			.title {
				margin-bottom: 1.5rem;

				.p1 {
					font-weight: bold;
					color: #161616;
					font-size: 1.8rem;
					line-height: 2.5rem;
				}

				.p2 {
					color: #999999;
					font-size: 1.4rem;
					line-height: 2rem;
				}
			}
		}

		.step {
			margin: 1rem 0;

			.box {
				font-size: 1.3rem;
				text-align: center;

				.icon {
					font-size: 1.9rem;
					margin-bottom: 0.2rem;
				}
			}
		}

		.inputbox {
			display: flex;
			margin-bottom: 0.8rem;
			margin-left: auto;
			margin-right: auto;
			border-bottom: 1px solid #ebebeb;
			padding: 1rem 0;
			line-height: 2.4rem;

			.input {
				padding: 0 0.5rem 0 0;
				line-height: 2.4rem;
				font-size: 1.6rem;
				color: #333333;
			}

			.label {
				color: #fa6b6b;
				font-size: 1.6rem;
				margin-right: 0.6rem;
			}

			.icon {
				vertical-align: -0.2rem;
				margin-right: 0.6rem;
			}

		}

		.bor0 {
			border-bottom: 0;
		}

		.tisp {
			font-size: 1rem;
			color: #999999;
			display: block;
			line-height: 1rem;
		}

		.img {
			margin-bottom: 1rem;
			margin-left: auto;
			margin-right: auto;
			display: block;
		}
	}
</style>
